import React from 'react';
import { CtaButton } from './CtaButton';
const pillars = ['Sessions.', 'Drills.', 'Progressions.', 'Management.', 'All organised.'];
export function FinalCta() {
  return <section className="w-full bg-court-950 py-20 text-white" aria-labelledby="final-cta-title" data-id="element-63" data-mp="19ez0vawwf414">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-64" data-mp="15ddgl4i1bngw">
        <h2 id="final-cta-title" className="font-display text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl" data-id="element-65" data-mp="15c2dl6weyjqu">
          Stop improvising.
          <span className="block text-ball" data-id="element-66" data-mp="1ed8xlpy9ucou">Start coaching with a system.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-court-600" data-id="element-67" data-mp="1t1wr7qok4cc5">
          Join hundreds of coaches worldwide who already plan their entire season in under 5
          minutes.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-3 gap-y-2 text-[11px] font-bold uppercase tracking-[0.16em] text-court-600" data-id="element-68" data-mp="224ef09jv1d19">
          {pillars.map(pillar => <li key={pillar} className="after:ml-3 after:text-court-700 after:content-['/'] last:after:content-['']" data-id="element-69" data-mp="n6dzj6dcrpoz">
              {pillar}
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-court-800 bg-court-900 p-8 sm:p-10" data-id="element-70" data-mp="x390rx10g46y">
          <p className="font-display text-xl font-black leading-tight tracking-tight sm:text-2xl" data-id="element-71" data-mp="122loejzphfal">
            🏆 Complete Package
            <span className="block" data-id="element-72" data-mp="163p14xmgiv7l">TENNIS 360™ — 12 Volumes + 6 Bonuses</span>
          </p>
          <p className="mt-6 flex flex-wrap items-center justify-center gap-4" data-id="element-73" data-mp="1b2i43w44b3ti">
            <span className="text-lg text-court-600 line-through" data-id="element-74" data-mp="1ftqfgxp0cz9b">$318</span>
            <span className="font-display text-5xl font-black leading-none text-ball" data-id="element-75" data-mp="1ktd21xqq7rus">$27</span>
            <span className="rounded-full bg-ball px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-court-950" data-id="element-76" data-mp="1psfxcqgwmjpk">
              Save $291
            </span>
          </p>
          <div className="mt-9" data-id="element-77" data-mp="1tub0m0ieb75z">
            <CtaButton className="w-full sm:w-auto" data-id="element-78" data-mp="3qufezt4b9qtq">🎾 Yes, I want my Tennis 360 now</CtaButton>
            <p className="mt-4 text-xs text-court-600" data-id="element-79" data-mp="3lvuertp2775a">
              🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-Day Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}